export default __webpack_public_path__ + "static/media/BorderRange.e6c828e1.jpg";